import { ref, watch } from 'vue'
import { useDetailNavigation } from '@/composables/useDetailNavigation'

const isOpen = ref(false)
const selectedSeriesId = ref<string | null>(null)

const { root: navigationRoot } = useDetailNavigation()

// A donation opened from the list replaces this detail. Same rule as above.
watch(
  () => navigationRoot.value?.kind,
  (kind) => {
    if (kind === 'recurring' || !isOpen.value) return
    isOpen.value = false
    selectedSeriesId.value = null
  }
)

/** Shared recurring-donation detail, opened from the schedules list. */
export function useRecurringDonationModal() {
  const { root, openRootRecurring, closeDetailNavigation } = useDetailNavigation()

  const openRecurringDonationModal = (seriesId: string) => {
    // The schedules list starts a fresh modal, replacing any open detail.
    selectedSeriesId.value = seriesId
    isOpen.value = true
    openRootRecurring(seriesId)
  }

  const closeRecurringDonationModal = () => {
    isOpen.value = false
    selectedSeriesId.value = null
    if (root.value?.kind === 'recurring') closeDetailNavigation()
  }

  return {
    isOpen,
    selectedSeriesId,
    openRecurringDonationModal,
    closeRecurringDonationModal,
  }
}
